import { type SetStateAction, useState } from "react";
import ErrorHandler from "@/services/ErrorService/ErrorService";

export const useLocalStorage = <T>(
	keyName: string,
	defaultValue: T,
): [T, React.Dispatch<React.SetStateAction<T>>] => {
	const [storedValue, setStoredValue] = useState<T>(() => {
		try {
			const value = window.localStorage.getItem(keyName);
			if (value) {
				return JSON.parse(value);
			}
			window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
			return defaultValue;
		} catch {
			return defaultValue;
		}
	});

	const setValue = (newValue: SetStateAction<T>) => {
		try {
			window.localStorage.setItem(keyName, JSON.stringify(newValue));
		} catch (error) {
			ErrorHandler.logError(error);
		}
		setStoredValue(newValue);
	};
	return [storedValue, setValue];
};
